import React from 'react';
import { Box, Button, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * The one line a read-only phone page shows about what it leaves out:
 * "Editing this is available on a computer." Desktop-only actions are not
 * rendered at all, never shown disabled.
 *
 * `withHomeLink` is for a deep link to a desktop-only screen, which has
 * nothing else to offer: it adds "Go to Home". `message` replaces the line
 * where a screen has its own words for it.
 */
export default function DesktopOnlyNote({ withHomeLink = false, message }) {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  return (
    <Box px="16px" py={withHomeLink ? '32px' : '12px'} textAlign={withHomeLink ? 'center' : 'left'}>
      <Text textStyle="phoneMeta" color="phone.muted">{message || t('phone.desktopOnly')}</Text>
      {withHomeLink && (
        <Button variant="phonePrimary" mt="20px" w="100%" onClick={() => navigate('/dashboard')}>
          {t('phone.goHome')}
        </Button>
      )}
    </Box>
  );
}
